
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { BrandingProvider } from "@/contexts/BrandingContext";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import Index from "./pages/Index";
import ITSMDashboard from "./pages/ITSMDashboard";
import NewTicket from "./pages/NewTicket";
import TicketDetails from "./pages/TicketDetails";
import InternalDashboard from "./pages/InternalDashboard";
import InternalTicketDetails from "./pages/InternalTicketDetails";
import AdminDashboard from "./pages/AdminDashboard";
import Login from "./pages/Login";
import Landing from "./pages/Landing";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import FAQ from "./pages/FAQ";
import SLA from "./pages/SLA";
import ServicePolicy from "./pages/ServicePolicy";
import ServiceCatalog from "./pages/ServiceCatalog";
import Reports from "./pages/Reports";
import NotFound from "./pages/NotFound";
import FloatingHelp from "./components/FloatingHelp";
import Documentation from "./pages/Documentation";
import EditProfile from "./pages/EditProfile";
import QueueManagement from "./pages/QueueManagement";
import ChangeManagement from "./pages/ChangeManagement";
import ApprovalQueue from "./pages/ApprovalQueue";
import ProblemManagement from "./pages/ProblemManagement";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <ThemeProvider>
      <LanguageProvider>
      <BrandingProvider>
        <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/landing" element={<Landing />} />
            <Route path="/cadastro" element={<Register />} />
            <Route path="/register" element={<Register />} />
            <Route path="/chamados" element={<ITSMDashboard />} />
            <Route path="/itsm" element={<ITSMDashboard />} />
            <Route path="/novo-chamado" element={<NewTicket />} />
            <Route path="/chamado/:id" element={<TicketDetails />} />
            <Route path="/atendimento" element={<InternalDashboard />} />
            <Route path="/atendimento/chamado/:id" element={<InternalTicketDetails />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/ajuda" element={<FAQ />} />
            <Route path="/sla" element={<SLA />} />
            <Route path="/politica-de-servico" element={<ServicePolicy />} />
            <Route path="/catalogo" element={<ServiceCatalog />} />
            <Route path="/catalogo-de-servicos" element={<ServiceCatalog />} />
            <Route path="/relatorios" element={<Reports />} />
            <Route path="/documentacao" element={<Documentation />} />
            <Route path="/editar-perfil" element={<EditProfile />} />
            <Route path="/filas" element={<QueueManagement />} />
            <Route path="/mudancas" element={<ChangeManagement />} />
            <Route path="/aprovacoes" element={<ApprovalQueue />} />
            <Route path="/problemas" element={<ProblemManagement />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <FloatingHelp />
        </BrowserRouter>
        </TooltipProvider>
      </BrandingProvider>
      </LanguageProvider>
    </ThemeProvider>
  </QueryClientProvider>
);

export default App;
